import { Injectable } from '@angular/core';
import { ShopLineItemMap } from '../models/payment-item.model';
import { Coupon, DiscountOrder, DiscountRequest } from '../models/restaurant.model';
import { DiscountType } from '../enums/util.enum';
import { CartStore } from '../stores/cart.store';
import { UrlParam } from '../enums/group-param.enum';
import { RestaurantStore } from '../stores/restaurant.store';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(
    private cartStore: CartStore,
    private restaurantStore: RestaurantStore,
    private router: Router
  ) { }

  public applyDiscountToOrder(shopLineItem: ShopLineItemMap): void {
    if (this.cartStore.discounts && this.cartStore.discounts.length > 0) {
      this.cartStore.discounts.forEach((discount: Coupon) => {
        switch (discount.type) {
          case (DiscountType.discount): shopLineItem[discount.locationId].discounts.push(new DiscountRequest(discount.id));
            break;
          case (DiscountType.coupon): this.setCoupons(discount);
            break;
        }
      });
    }
  }

  public removeDiscountFromStorage(): void {
    if (sessionStorage.getItem(UrlParam.discount)) {
      sessionStorage.removeItem(UrlParam.discount);
      this.restaurantStore.discountPromo = null;
      this.router.navigate([], {
        queryParams: null }
      );
    }
  }

  private setCoupons(discount: Coupon): void {
    const coupons = this.cartStore.getCoupons();
    if (!coupons.some(coupon => coupon.id === discount.id)) {
      coupons.push(new DiscountOrder(discount.id));
      this.cartStore.setCoupons(coupons);
    }
  }
}
